import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AppSurfaceService } from '@core/config/app-surface.service';
import { UserQuery } from '@core/store/user/user.query';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { V2_ICONS } from '@v2/v2.icons';
import { v2TabBarItems } from '@v2/shared/v2-nav';

/**
 * The phone's bottom navigation, shown below 880px where the rail is not.
 *
 * New behaviour: the app has no mobile navigation at all today. Four
 * destinations for every viewer -- `v2TabBarItems` guarantees the count, so
 * the bar never changes width between an admin and a client.
 */
@Component({
  selector: 'app-v2-tab-bar',
  templateUrl: './v2-tab-bar.component.html',
  styleUrls: ['./v2-tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIcon, RouterLink, RouterLinkActive],
  providers: [provideIcons(V2_ICONS)],
})
export class V2TabBarComponent {
  private readonly userQuery = inject(UserQuery);
  private readonly surface = inject(AppSurfaceService);

  /** `null` until the user request settles; that reads as not-an-admin. */
  private readonly user = toSignal(this.userQuery.getUser$, { initialValue: null });

  protected readonly items = computed(() => v2TabBarItems(this.user(), this.surface.current));
}
